import {getPlayerLeaderboards} from '@/api/api';
import {useQuery} from '@tanstack/react-query';

export const useGetLeaderboardList = ({mboClientId, locationId}: {mboClientId?: string; locationId?: string}) => {
  return useQuery({
    queryKey: ['leaderboard-list', mboClientId],
    queryFn: () => getPlayerLeaderboards().then((res) => res.data),
    enabled: !!mboClientId && !!locationId,
    refetchOnWindowFocus: false,
  });
};
